<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อัพโหลดไฟล์เรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_status === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบรูปภาพเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="grid_flex pa-2">
          <div>
            <v-card-title>
              การแสดงผลหน้าเว็บไซต์
            </v-card-title>
          </div>
          <div class="text-right ma-2">
            <v-btn x-large class="text-center grad-success-bg white--text btn_size" @click="image_modal = true">เพิ่มรูปภาพ</v-btn>
          </div>
        </div>
        <div class="grid_content">
          <div class="ma-2 padding_img">
            <v-img :src="img_holder"></v-img>
          </div>
          <div>
            <div>
              <div v-if="loading_list === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                  <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
              </div>
              <div v-else class="ma-2">
                <div v-for="(data, index) in data_list" :key="index">
                  <v-card elevation="2" class="pa-2 ma-2">
                    <div class="grid_item">
                      <div class="ml-2 grid_picture">
                        <div class="grid_mx">
                          <v-img class="rounded" height="120" width="120" max-width="120" v-if="data.img === ''" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                          <v-img class="rounded" height="120" width="120" max-width="120" v-else-if="data.img !== ''" :lazy-src="picture_holder" :src="data.img"></v-img>
                        </div>
                        <div class="ml-3 pt-7">
                          <div style="font-size: 18px">Upload {{ data.created_at }}</div>
                          <div style="font-size: 18px">By: {{ data.user_name }}</div>
                        </div>
                      </div>
                      <div>
                        <div class="text-right">
                          <div class="item_grid">
                            <div>แสดงหน้าเว็บไซต์</div>
                            <v-switch class="mt-0 ml-3" color="#86bc3a" @change="changeStatus(data.id, data.status)" v-model="data.status"></v-switch>
                          </div>
                          <div>
                            <v-btn small height="42" class="grad-danger-bg white--text mb-1 mobile_btn" @click="image_remove(data.loop_id, data.id)" title="ลบรูปภาพ">
                              <v-icon>mdi-delete-empty-outline</v-icon>ลบรูปภาพ
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
      <v-dialog v-model="image_modal" max-width="520">
        <v-card>
          <v-form ref="image" @submit.prevent="">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เพิ่มรูปภาพ
              </v-card-title>
              <v-btn icon class="ma-4" @click="image_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-4">
                  <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                  <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                </div>
                <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มรูปภาพปกเว็บไซต์" v-model="cover_image" @change="onFileChange"></v-file-input>
                <div class="mt-6">
                  <v-btn x-large v-if="imagePreviewURL == null" class="white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                  <v-btn x-large v-if="imagePreviewURL !== null" class="white--text grad-success-bg btn_size" @click="upload_image">อัพโหลด</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script>
<script>
import img_holder from "@/assets/img_main.jpg";
import picture_holder from "@/assets/picture.png";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Cover_setting",
  data() {
    return {
      alert_success: false,
      alert_status: false,
      alert_delete: false,
      overlay: false,
      loading_page: false,
      loading_list: false,
      image_modal: false,
      img_holder: img_holder,
      picture_holder: picture_holder,
      imagePreviewURL: null,
      cover_image: null,
      image: null,
      data_list: [],
      loop_id: 0,
    }
  },
  methods: {
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.cover_image = null
          })
        }else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.cover_image = null
          }
        }
      } else {
        this.imagePreviewURL = null
        this.cover_image = null
      }
    },
    get_cover_img() {
      this.data_list = []
      this.loading_list = true
      HTTP.post('/manage-website/coverimage/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_list = false
              res.data.object.forEach((data) => {
                const loop_id = this.loop_id +=1
                this.data_list.push({
                  loop_id: loop_id,
                  id: data.id,
                  img: data.img,
                  status: data.status,
                  order: data.order,
                  user_name: data.user_name,
                  created_at: data.created_at
                })
              })
            }
          })
    },
    upload_image() {
      let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
      let file = this.cover_image.name;
      let ext = file.split('.').pop().toLowerCase();
      if (parseInt(extall.indexOf(ext)) < 0) {
        Swal.fire({
          text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.imagePreviewURL = null
          this.cover_image = null
        })
      }
      else {
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        let formData = new FormData();
        formData.append('cover_image', this.cover_image, this.cover_image.name)
        formData.append('user_id', this.$store.state.userDetail.id)
        formData.append('user_name', this.$store.state.userDetail.name)
        this.overlay = true
        this.image_modal = false
        HTTP.post('/manage-website/coverimage/create', formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.imagePreviewURL = null
                this.cover_image = null
                this.get_cover_img()
                this.alert_success = true
                setTimeout(() => this.alert_success = false,3000)
              }
            })
      }
    },
    changeStatus(id, status) {
      HTTP.post('/manage-website/coverimage/editstatus', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_status = true
          setTimeout(() => this.alert_status = false, 3000)
        }
      })
    },
    image_remove(loop_id, id) {
      Swal.fire({
        title: 'คุณต้องการลบรูปภาพหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/coverimage/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_delete = true
              setTimeout(() => this.alert_delete = false, 3000)
              this.data_list = this.data_list.filter(detail => detail.loop_id !== loop_id)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.get_cover_img()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.grid_content {
  display: grid;
  grid-template-columns: 40% 60%;
}
.grid_item {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 15px 0;
}
.btn_size {
  width: 100%;
}
.item_grid {
  display: flex;
  justify-content: right;
}
.mobile_btn {
  width: 70%;
}
.padding_img {
  padding: 0;
}
.grid_picture {
  display: flex;
}
.grid_mx {
  margin: 0;
}
@media only screen and (max-width: 1180px) {
  .grid_content {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .padding_img {
    padding: 30px;
  }
  .grid_picture {
    display: grid;
    grid-template-columns: 25% 80%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_picture {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_item {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .item_grid {
    display: flex;
    justify-content: left;
  }
  .mobile_btn {
    width: 100%;
  }
  .padding_img {
    padding: 0;
  }
  .grid_mx {
    margin: auto;
  }
}
</style>
